import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { kycAuthSuccess, kycAuthFailure } from "../../Action/kyc/kycAuthAction";
import { ACCEPT_REJECT } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* kycAuthRequest(action) {
  try {
    const { data } = yield API.post("/kycauth", action?.payload?.payload);
    if (data?.meta?.code === 200) {
      yield put(kycAuthSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(kycAuthFailure());
      notifyError("Invalid Request")
    }
  } catch (error) {
    yield put(kycAuthFailure());
    notifyError("Invalid Request")
  }
}

export function* watchKYCAuthAPI() {
  yield takeEvery(ACCEPT_REJECT, kycAuthRequest);
}

export default function* rootSaga() {
  yield all([watchKYCAuthAPI()]);
}
